export default "__VITE_ASSET__BtPMH1k9__"